export default __webpack_public_path__ + "static/media/testador2.92b675e7.png";